export default {
  id: 'f6bad9db44',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page th" data-name="transaction">\n\n    <!-- Navbar -->\n    <div class="navbar th__navbar no-shadow">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left">\n          <a href="#" class="link back th__back" aria-label="Back">\n            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>\n          </a>\n        </div>\n        <div class="title th__navbar-title">History</div>\n        <div class="right"></div>\n      </div>\n    </div>\n\n    <div class="page-content th__content" data-type="';
      r += c(ctx_1.type, ctx_1);
      r += '">\n\n      <!-- Tabs -->\n      <div class="th__tabs">\n        <button type="button" class="th__tab th__tab--on" data-tab="payments">\n          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>\n          <span>Payments</span>\n        </button>\n        <button type="button" class="th__tab" data-tab="commissions">\n          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>\n          <span>Commissions</span>\n        </button>\n        <button type="button" class="th__tab" data-tab="withdrawals">\n          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>\n          <span>Withdrawals</span>\n        </button>\n      </div>\n\n      <!-- Status filter (full-width segmented control) -->\n      <div class="th__filter-cap">\n        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>\n        Filter by status\n      </div>\n      <div class="th__filters">\n        <button type="button" class="th__filter th__filter--on" data-status="all">All<span class="th__filter-c">0</span></button>\n        <button type="button" class="th__filter" data-status="success">Success<span class="th__filter-c">0</span></button>\n        <button type="button" class="th__filter" data-status="pending">Pending<span class="th__filter-c">0</span></button>\n        <button type="button" class="th__filter" data-status="failed">Failed<span class="th__filter-c">0</span></button>\n      </div>\n\n      <!-- List (rendered by routes.js) -->\n      <div class="th__list"></div>\n\n      <div class="th__end-gap"></div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  style: `
/* ════════ TRANSACTION HISTORY (th__*) ════════ */
.th { background: #0A0A0B !important; }
.th__content {
  background:
    radial-gradient(130% 45% at 50% 0%, rgba(201,169,105,0.10) 0%, transparent 56%),
    #0A0A0B !important;
  padding: 14px 14px calc(40px + env(safe-area-inset-bottom)) !important;
  margin-top: 60px !important;
}
.th__navbar { background: linear-gradient(180deg, #100E09 0%, #0B0A07 100%) !important; }
.th__navbar .navbar-bg { background: transparent !important; }
.th__navbar-title { color: var(--gold) !important; font-weight: 700; }
.th__back { color: rgba(201,169,105,0.85) !important; }

/* Tabs — segmented pill with a solid gold active pill */
.th__tabs {
  display: flex; gap: 4px; padding: 4px; border-radius: 15px;
  background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08);
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.3);
}
.th__tab {
  flex: 1; min-width: 0; cursor: pointer;
  display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 6px;
  padding: 10px 6px; border-radius: 12px; border: none; background: transparent;
  color: rgba(255,255,255,0.55); font-size: 12px; font-weight: 700;
  white-space: nowrap; overflow: hidden;
  transition: background .2s ease, color .2s ease, box-shadow .2s ease, transform .12s ease;
}
.th__tab span { overflow: hidden; text-overflow: ellipsis; }
.th__tab svg { opacity: 0.7; flex-shrink: 0; }
.th__tab:active { transform: scale(0.97); }
.th__tab--on {
  background: linear-gradient(135deg, #e5c98f 0%, #C9A969 48%, #a07c38 100%);
  color: #1a1206;
  box-shadow: 0 8px 18px -8px rgba(201,169,105,0.75), inset 0 1px 0 rgba(255,255,255,0.4);
}
.th__tab--on svg { opacity: 1; }

/* Filters — full-width segmented status control (secondary to the tabs).
   NOTE: F7's base rule button{width:100%} forces bare buttons full-width, so the
   segments MUST use flex:1 (flex-basis:0 overrides that width), same as .th__tab. */
.th__filter-cap {
  display: flex; align-items: center; gap: 6px; margin: 16px 2px 8px;
  font-size: 11px; font-weight: 700; letter-spacing: 0.05em; text-transform: uppercase;
  color: rgba(201,169,105,0.62);
}
.th__filter-cap svg { color: rgba(201,169,105,0.7); }
.th__filters {
  display: flex; gap: 4px; padding: 4px; border-radius: 13px;
  background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08);
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.25);
}
.th__filter {
  flex: 1; min-width: 0; cursor: pointer;
  display: inline-flex; align-items: center; justify-content: center; gap: 4px;
  padding: 9px 4px; border-radius: 10px; border: 1px solid transparent; background: transparent;
  color: rgba(255,255,255,0.58); font-size: 11.5px; font-weight: 700; white-space: nowrap;
  transition: background .16s ease, color .16s ease, border-color .16s ease, transform .12s ease;
}
.th__filter:active { transform: scale(0.97); }
.th__filter-c {
  font-size: 10.5px; font-weight: 800; color: rgba(255,255,255,0.42);
  font-variant-numeric: tabular-nums;
}
.th__filter-c::before { content: '('; }
.th__filter-c::after  { content: ')'; }
/* Active segment adopts its own status color */
.th__filter--on { color: #fff; }
.th__filter--on .th__filter-c { color: currentColor; opacity: 0.8; }
.th__filter--on[data-status="all"]     { background: linear-gradient(155deg, rgba(201,169,105,0.26), rgba(201,169,105,0.07)); border-color: rgba(201,169,105,0.45); color: #f3e2b6; }
.th__filter--on[data-status="success"] { background: linear-gradient(155deg, rgba(74,222,128,0.22), rgba(74,222,128,0.06)); border-color: rgba(74,222,128,0.42); color: #bff2d3; }
.th__filter--on[data-status="pending"] { background: linear-gradient(155deg, rgba(251,191,36,0.22), rgba(251,191,36,0.06)); border-color: rgba(251,191,36,0.42); color: #f7e3b2; }
.th__filter--on[data-status="failed"]  { background: linear-gradient(155deg, rgba(248,113,113,0.22), rgba(248,113,113,0.06)); border-color: rgba(248,113,113,0.42); color: #f7c6c6; }

/* List */
.th__list { margin-top: 16px; display: flex; flex-direction: column; }

/* Day group header (Today / Yesterday / date) */
.th__day {
  font-size: 10.5px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase;
  color: rgba(201,169,105,0.62); margin: 10px 3px 8px;
}
.th__day:first-child { margin-top: 2px; }

.th__item {
  position: relative; overflow: hidden;
  display: flex; align-items: flex-start; gap: 12px; margin-bottom: 10px;
  padding: 13px 14px 13px 18px;
  background: linear-gradient(160deg, #17140f 0%, #110f0d 100%);
  border: 1px solid rgba(201,169,105,0.12); border-radius: 16px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.04), 0 10px 22px -16px rgba(0,0,0,0.75);
  transition: border-color 0.14s ease, transform 0.12s ease;
}
.th__item:active { transform: scale(0.992); border-color: rgba(201,169,105,0.30); }
/* Leading accent bar — colored by direction (green in / red out) */
.th__item::before {
  content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 3.5px;
}
.th__item--in::before  { background: linear-gradient(180deg, #4ADE80, rgba(74,222,128,0.25)); }
.th__item--out::before { background: linear-gradient(180deg, #F87171, rgba(248,113,113,0.25)); }
.th__item-ico {
  flex-shrink: 0; width: 40px; height: 40px; border-radius: 12px; margin-top: 1px;
  display: flex; align-items: center; justify-content: center;
}
.th__item-ico--out { background: linear-gradient(160deg, rgba(248,113,113,0.17), rgba(248,113,113,0.05)); color: #F87171; box-shadow: inset 0 0 0 1px rgba(248,113,113,0.20); }
.th__item-ico--in  { background: linear-gradient(160deg, rgba(74,222,128,0.17), rgba(74,222,128,0.05)); color: #4ADE80; box-shadow: inset 0 0 0 1px rgba(74,222,128,0.20); }
.th__item-body { flex: 1; min-width: 0; }
.th__item-top { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; }
.th__item-title { font-size: 14px; font-weight: 700; color: #fff; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.th__item-amt { flex-shrink: 0; font-size: 15.5px; font-weight: 800; white-space: nowrap; font-variant-numeric: tabular-nums; letter-spacing: -0.01em; }
.th__item-amt--out { color: #fff; }
.th__item-amt--in { color: #4ADE80; }
.th__item-meta { display: flex; align-items: center; gap: 8px; margin-top: 7px; flex-wrap: nowrap; min-width: 0; }
.th__badge { flex-shrink: 0; display: inline-flex; align-items: center; gap: 5px; padding: 4px 9px; border-radius: 20px; font-size: 10px; font-weight: 700; }
.th__badge-dot { width: 5px; height: 5px; border-radius: 50%; }
.th__badge--success { background: rgba(74,222,128,0.12); color: #4ADE80; } .th__badge--success .th__badge-dot { background: #4ADE80; }
.th__badge--pending { background: rgba(251,191,36,0.12); color: #fbbf24; } .th__badge--pending .th__badge-dot { background: #fbbf24; }
.th__badge--failed  { background: rgba(248,113,113,0.12); color: #F87171; } .th__badge--failed .th__badge-dot { background: #F87171; }
.th__item-sub { flex: 1; min-width: 0; font-size: 11.5px; font-weight: 600; color: rgba(255,255,255,0.5); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

/* Footer — REF tag, chips and date, split by a hairline */
.th__item-foot {
  display: flex; align-items: center; flex-wrap: wrap; gap: 7px;
  margin-top: 10px; padding-top: 9px;
  border-top: 1px dashed rgba(255,255,255,0.08);
}
.th__ref { display: inline-flex; align-items: center; gap: 6px; min-width: 0; }
.th__ref-tag {
  flex-shrink: 0; font-size: 8.5px; font-weight: 800; letter-spacing: 0.08em;
  color: rgba(201,169,105,0.85); background: rgba(201,169,105,0.10);
  border: 1px solid rgba(201,169,105,0.22); border-radius: 5px; padding: 2px 6px;
}
.th__ref-id {
  font-size: 10.5px; font-weight: 600; color: rgba(255,255,255,0.5);
  font-variant-numeric: tabular-nums; letter-spacing: 0.02em;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 150px;
}
.th__chip {
  display: inline-flex; align-items: center; padding: 3px 9px; border-radius: 8px;
  background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.08);
  font-size: 10.5px; font-weight: 600; color: rgba(255,255,255,0.6);
  font-variant-numeric: tabular-nums; white-space: nowrap;
}
.th__chip--bal { color: rgba(223,194,136,0.9); background: rgba(201,169,105,0.08); border-color: rgba(201,169,105,0.16); }
.th__item-date {
  margin-left: auto; font-size: 10.5px; color: rgba(255,255,255,0.4);
  font-variant-numeric: tabular-nums; letter-spacing: 0.01em; white-space: nowrap;
}
/* withdrawal-card meta pill (kept for the breakdown card) */
.th__item-extra {
  display: inline-flex; align-items: center; padding: 4px 10px; border-radius: 8px;
  background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.07);
  font-size: 11px; font-weight: 600; color: rgba(223,194,136,0.88); font-variant-numeric: tabular-nums;
}

/* loading */
.th__loading {
  display: flex; align-items: center; justify-content: center; gap: 9px;
  padding: 40px 0; font-size: 13px; color: rgba(255,255,255,0.42);
}
.th__spin-ring {
  width: 17px; height: 17px; border-radius: 50%; flex-shrink: 0;
  border: 2px solid rgba(201,169,105,0.25); border-top-color: #C9A969;
  animation: th-spin 0.8s linear infinite;
}
@keyframes th-spin { to { transform: rotate(360deg); } }

/* rich empty / error state */
.th__empty {
  display: flex; flex-direction: column; align-items: center;
  text-align: center; padding: 48px 28px 40px;
}
.th__empty-ico {
  width: 64px; height: 64px; border-radius: 20px; margin: 0 auto 16px;
  display: flex; align-items: center; justify-content: center; position: relative;
  background: radial-gradient(120% 120% at 50% 0%, rgba(201,169,105,0.16), rgba(201,169,105,0.05));
  box-shadow: inset 0 0 0 1px rgba(201,169,105,0.20); color: #C9A969;
}
.th__empty-ico::after {
  content: ''; position: absolute; inset: -6px; border-radius: 24px;
  border: 1px solid rgba(255,255,255,0.04);
}
.th__empty-ico--err {
  background: radial-gradient(120% 120% at 50% 0%, rgba(248,113,113,0.14), rgba(248,113,113,0.04));
  box-shadow: inset 0 0 0 1px rgba(248,113,113,0.18); color: #F87171;
}
.th__empty-title { font-size: 15px; font-weight: 700; color: rgba(255,255,255,0.82); margin: 0; }
.th__empty-sub { font-size: 12.5px; color: rgba(255,255,255,0.40); margin: 7px 0 0; line-height: 1.55; max-width: 250px; }

.th__end-gap { height: 30px; }

/* ── Withdrawal card ── */
.th__wd-card {
  flex-direction: column; gap: 11px;
  padding: 14px 13px 13px;
}
.th__wd-head { display: flex; align-items: center; gap: 11px; }
.th__wd-info { flex: 1; min-width: 0; }
.th__wd-name {
  display: block; font-size: 14px; font-weight: 650; color: rgba(255,255,255,0.92);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.th__wd-dest {
  display: block; font-size: 11px; color: rgba(255,255,255,0.42); margin-top: 3px;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.th__wd-breakdown {
  display: grid; grid-template-columns: 1fr 1px 1fr 1px auto;
  align-items: center;
  border-radius: 13px; overflow: hidden;
  border: 1px solid rgba(255,255,255,0.08);
  width: 95%; max-width: 100%; margin: 0 auto;
}
.th__wd-col {
  display: flex; flex-direction: column; align-items: center; gap: 5px;
  padding: 11px 6px;
  background: rgba(0,0,0,0.2);
}
.th__wd-col--net {
  background: linear-gradient(160deg, rgba(74,222,128,0.12), rgba(74,222,128,0.04));
  padding: 11px 12px;
}
.th__wd-sep { background: rgba(255,255,255,0.07); justify-self: stretch; }
.th__wd-lbl {
  font-size: 9px; font-weight: 600; color: rgba(255,255,255,0.35);
  text-transform: uppercase; letter-spacing: 0.04em; white-space: nowrap;
}
.th__wd-lbl--net { color: rgba(74,222,128,0.55); }
.th__wd-val { font-size: 13px; font-weight: 800; color: rgba(255,255,255,0.85); white-space: nowrap; font-variant-numeric: tabular-nums; }
.th__wd-val--fee { color: rgba(248,113,113,0.90); }
.th__wd-val--net { font-size: 15px; font-weight: 800; color: #4ADE80; }
.th__wd-foot {
  display: flex; align-items: center; justify-content: space-between; gap: 8px;
}
.th__wd-date { font-size: 10px; color: rgba(255,255,255,0.32); }
`,
  styleScoped: false
};